import { render, staticRenderFns } from "./view-modal-donation.vue?vue&type=template&id=675c644d&"
import script from "./view-modal-donation.vue?vue&type=script&lang=js&"
export * from "./view-modal-donation.vue?vue&type=script&lang=js&"
import style0 from "./view-modal-donation.vue?vue&type=style&index=0&id=675c644d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports